import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tryFlag:false
  },
  getters: {
  },
  mutations: {
    changeTryFlag(state,flag){
      state.tryFlag=flag
    }
  },
  actions: {
  },
  modules: {
  }
})
